import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import GridViewIcon from '@mui/icons-material/GridView';
import HistoryIcon from '@mui/icons-material/History';
import { useTranslation } from 'react-i18next';

/** Design screen 12: what a user sees after removing every widget. */
export default function EmptyDashboard({ onAdd, onPresets, onRestore }) {
  const { t } = useTranslation();
  return (
    <Box data-testid="dashboard-empty" sx={{ border: '1.5px dashed #cbd5e1', borderRadius: '12px', minHeight: 420, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1.5, p: 3, textAlign: 'center' }}>
      <Box sx={{ width: 64, height: 64, borderRadius: '16px', bgcolor: 'rgba(49,130,206,0.10)', color: 'secondary.main', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <DashboardCustomizeIcon sx={{ fontSize: 32 }} />
      </Box>
      <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{t('dashboard.emptyDashboard.title')}</Typography>
      <Typography sx={{ fontSize: 14, color: 'text.secondary', maxWidth: 420 }}>{t('dashboard.emptyDashboard.text')}</Typography>
      <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap', justifyContent: 'center', mt: 1 }}>
        <Button variant="contained" color="secondary" startIcon={<AddIcon />} onClick={onAdd} sx={{ borderRadius: '10px' }}>
          {t('dashboard.edit.addWidget')}
        </Button>
        <Button variant="outlined" startIcon={<GridViewIcon />} onClick={onPresets} sx={{ borderRadius: '10px', borderColor: 'divider', color: 'text.primary' }}>
          {t('dashboard.edit.presets')}
        </Button>
      </Box>
      <Button variant="text" startIcon={<HistoryIcon />} onClick={onRestore} data-testid="dashboard-empty-restore" sx={{ color: 'secondary.main' }}>
        {t('dashboard.presets.restoreClassic')}
      </Button>
    </Box>
  );
}
